import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Form, Select } from 'antd';
import { disabledDate, disabledTime } from '../../utils/getPastTime';
import { DefaultRangePicker, getColor } from '@lib/common';
import { FieldLabel, SectionHeader } from '../field-label.component';
import moment from 'moment';
import { StyledInputNumber, renderDescriptionInput, renderExpectationItem, renderPasswordInput, renderShowExplanationSwitchOption, renderShuffleAnswerOption, renderShuffleQuestionOption, renderTitleInput } from './base-options.component';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var StyledWrapper = styled.div.withConfig({
  displayName: "create-practice-optionscomponent__StyledWrapper",
  componentId: "sc-z5p9mk-0"
})(["background-color:", ";padding:16px;border:1px solid #e6e8f0;border-radius:8px;margin-bottom:16px;"], getColor('fillBgSub'));
export var CreatePracticeOptions = function CreatePracticeOptions(props) {
  var label = props.label,
      errorLabel = props.errorLabel,
      formTotalScore = props.formTotalScore,
      onFormValuesChange = props.onFormValuesChange;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.basicInformation,
        description: label.basicInformationDescription
      }), renderTitleInput(label, errorLabel), renderDescriptionInput(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.timeAndAttempts,
        description: label.timeAndAttemptsDescription
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.durationAssignment,
          hint: label.durationHint,
          required: true
        }),
        name: "duration",
        initialValue: 30,
        dependencies: ['rangeDate'],
        required: true,
        rules: [function (_ref) {
          var getFieldValue = _ref.getFieldValue;
          return {
            validator: function () {
              var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, value) {
                var isValidRange, diffRangeDate, rangeDate, isDurationLessThanDateRange;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        isValidRange = value && value < 1;

                        if (!isValidRange) {
                          _context.next = 3;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(errorLabel.durationIsNotValid));

                      case 3:
                        rangeDate = getFieldValue('rangeDate');

                        if (rangeDate && rangeDate.length === 2) {
                          diffRangeDate = moment(rangeDate[1]).startOf('minute').diff(moment(rangeDate[0]).startOf('minute'), 'minutes');
                        }

                        isDurationLessThanDateRange = getFieldValue('rangeDate') && value > diffRangeDate;

                        if (!isDurationLessThanDateRange) {
                          _context.next = 8;
                          break;
                        }

                        return _context.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                      case 8:
                        return _context.abrupt("return", Promise.resolve());

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function validator(_x, _x2) {
                return _validator.apply(this, arguments);
              }

              return validator;
            }()
          };
        }],
        children: /*#__PURE__*/_jsx(StyledInputNumber, {
          min: 0,
          addonAfter: label.minute
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "rangeDate",
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.deadline,
          hint: label.deadlineHint
        }),
        dependencies: ['duration'],
        rules: [{
          required: false,
          message: errorLabel.selectDeadlineMessage
        }, function (_ref2) {
          var getFieldValue = _ref2.getFieldValue;
          return {
            validator: function validator(_, value) {
              var diffRangeDate;

              if (value && value.length === 2) {
                diffRangeDate = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');
              }

              if (!value || getFieldValue('duration') <= diffRangeDate) {
                return Promise.resolve();
              }

              return Promise.reject(new Error("".concat(errorLabel.warningStartAndEndTime, "!")));
            }
          };
        }],
        children: /*#__PURE__*/_jsx(DefaultRangePicker, {
          disabledDate: disabledDate,
          disabledTime: disabledTime,
          showTime: {
            format: 'HH:mm'
          },
          format: "DD/MM/YYYY - HH:mm",
          placeholder: [label.startTime, label.endTime]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "numberOfSubmission",
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.maxNumberOfSubmission,
          hint: label.maxNumberOfSubmissionHint,
          required: true
        }),
        initialValue: -1,
        rules: [{
          required: true,
          message: errorLabel.missingNumberOfSubmission
        }],
        children: /*#__PURE__*/_jsxs(Select, {
          size: "middle",
          placeholder: label.numberOfSubmissionPlaceholder,
          children: [/*#__PURE__*/_jsx(Option, {
            value: 1,
            children: "1"
          }), /*#__PURE__*/_jsx(Option, {
            value: 2,
            children: "2"
          }), /*#__PURE__*/_jsx(Option, {
            value: 3,
            children: "3"
          }), /*#__PURE__*/_jsx(Option, {
            value: -1,
            children: label.unlimitedNumberOfEditSubmission
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.shareAndAccess,
        description: label.shareAndAccessDescription
      }), renderPasswordInput(label, errorLabel)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.shuffleSettings,
        description: label.shuffleSettingsDescription
      }), renderShuffleQuestionOption(label), renderShuffleAnswerOption(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.scoringAndResults,
        description: label.scoringAndResultsDescription
      }), renderShowExplanationSwitchOption(label), renderExpectationItem(label, errorLabel, true, formTotalScore, onFormValuesChange)]
    })]
  });
};